import { PptFilter } from "./types";

export const defaultPptsFilters: PptFilter = {
  region: "",
  tier: "",
};
